<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light">


                <b-form-row @keyup.enter="load">

                    <b-col lg="10" sm="10">
                        <b-form-group label="Exercício Fiscal:" class="col-3">
                            <b-form-select @change="load" v-model="ano" :options="anos"></b-form-select>
                        </b-form-group>
                    </b-col>

                    <b-col lg="2" sm="2" class="d-flex align-items-center justify-content-end">
                        <div v-if="this.ano && this.form.almoxarifado && this.form.almoxarifado.id"
                            :id="'relatoriogeral-'">
                            <img @click="abrirModalRelatorio" :src="pdf" class="img img--clickable" alt="pdf" />
                            <b-tooltip :target="'relatoriogeral-'" title="Abrir Modal de relatórios" />
                        </div>
                    </b-col>

                    <b-col>
                        <LgFinderPageAlmoxarifado id="finderAlmoxarifadoToConsumo" @onselect="handleSelectAlmoxarifado"
                            v-model="form.almoxarifado" :prefix="prefix + title + ' > '" />
                    </b-col>
                    <b-col>
                        <LgFinderPageProduto id="finderProduto" @onselect="handleSelectProduto" v-model="form.produto"
                            :prefix="prefix + title + ' > '" />
                    </b-col>
                    <b-col>
                        <LgFinderPagePessoa :mostrarComissao="true" :prefix="prefix + title + ' > '"
                            id="finderResponsavel" label="Pessoa:" @onselect="handleSelectResponsavel"
                            v-model="form.pessoaComissao" @onselectComissao="handleSelectComissao"
                            invalidFeedback="Informe uma pessoa!" />
                    </b-col>

                    <b-col class="d-flex align-items-center justify-content-end">

                        <b-button v-if="temPrivilegioInclusao() && anoAtual == ano && !inventarioAnual" id="novo"
                            class="ml-3 mr-2 my-2" style="height: 20px" @click="openCreateModal" size="sm" pill
                            variant="secondary">
                            <div class="btn-size-alinhamento">
                                <b-icon scale="1" icon="plus" />
                            </div>
                            <b-tooltip target="novo" title="Adicionar novo..."></b-tooltip>

                        </b-button>

                        <b-button id="localizar" class="ml-1" size="sm" style="height: 20px" pill variant="primary"
                            @click="load">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="search" />
                            </div>
                            <b-tooltip target="localizar" title="Localizar"></b-tooltip>
                        </b-button>

                        <b-button id="limpar" class="mr-2" size="sm" style="height: 20px" pill variant="primary"
                            @click="clearForm">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="eraser" />
                            </div>
                            <b-tooltip target="limpar" title="Limpar"></b-tooltip>
                        </b-button>


                    </b-col>
                </b-form-row>

                <b-form-row @keyup.enter="load">
                    <b-col>
                        <LgFinderPageSubgrupoProduto id="finderSubgrupo" @onSelect="handleSelectSubgrupo"
                            v-model="form.subgrupo" :prefix="prefix + title + ' > '" />
                    </b-col>
                    <b-col>
                        <LgFinderPageClasse id="finderClasse" @onselect="handleSelectClasse" v-model="form.classe"
                            :prefix="prefix + title + ' > '" />
                    </b-col>
                </b-form-row>

                <b-form-row @keyup.enter="load">
                    <b-col>
                        <LgFinderPageLocalArmazenamento id="finderLocalArmazenamento1"
                            @input="handleSelectLocalArmazenamento1" v-model="form.localArmazenamento1"
                            :prefix="prefix + title + ' > '" label="Local Armazenamento 1:" />
                    </b-col>
                </b-form-row>
                <b-form-row @keyup.enter="load">
                    <b-col>
                        <LgFinderPageLocalArmazenamento id="finderLocalArmazenamento2"
                            @input="handleSelectLocalArmazenamento2" :prefix="prefix + title + ' > '"
                            v-model="form.localArmazenamento2" label="Local Armazenamento 2:" />
                    </b-col>
                    <b-col class="d-flex align-items-center justify-content-start">
                        <b-form-checkbox class="mr-2" @change="load" :disabled="apenasSaldoPositivo"
                            v-model="form.saldoPositivo" name="saldoPositivo" :value="true"
                            :unchecked-value="false">Saldo Positivo</b-form-checkbox>
                        <b-form-checkbox @change="load" v-model="form.itensSemContagem" name="itensSemContagem"
                            :value="true" :unchecked-value="false">Apenas itens sem contagem</b-form-checkbox>

                    </b-col>
                </b-form-row>
                <b-form-row @keyup.enter="load">
                    <b-col>
                        <LgFormConstSelect label="Disponibilidade:" @change="load" v-model="form.disponibilidade"
                            :options="[
                                { value: null, text: 'Todos' },
                                { value: 0, text: 'Disponível' },
                                { value: 1, text: 'Bloqueado' },
                            ]"></LgFormConstSelect>
                    </b-col>
                    <b-col>
                        <LgFormConstSelect @change="load" label="Visibilidade:" v-model="form.visibilidade" :options="[
                            { value: null, text: 'Todos' },
                            { value: 1, text: 'Visível' },
                            { value: 0, text: 'Invisível' },
                        ]"></LgFormConstSelect>
                    </b-col>
                </b-form-row>


            </b-card>

            <b-card bg-variant="light">
                <div v-if="this.ano && this.form.almoxarifado && this.form.almoxarifado.id"
                    class="d-flex align-items-center mb-2">
                    <span class="mr-3" style="font-weight: 500; color: #495057;">
                        {{ produtosSelecionados.length }} produto(s) selecionado(s)
                    </span>
                    <b-button v-if="produtosSelecionados.length > 0"
                        v-b-tooltip.hover.bottom="'Adicionar múltiplas contagens'" @click="openCreateModalMultiplo"
                        size="sm" pill variant="secondary">
                        <b-icon scale="1" icon="plus" class="mr-1" />
                        Adicionar contagens
                    </b-button>
                </div>
                <b-table v-if="this.ano && this.form.almoxarifado && this.form.almoxarifado.id" :items="records"
                    :fields="tableFields" :busy="busy" small hover show-empty>



                    <template #row-details="row">
                        <div v-for="(item, index) in row.item.data" :key="index" class="subrowWrapper" style="
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 12px;
            padding: 12px 16px;
            border: 1px solid #ccc;
            border-radius: 10px;
            margin-bottom: 12px;
        ">
                            <div class="subrow" style="
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding-bottom: 8px;
                border-bottom: 1px solid #ddd;
                gap: 12px;
            ">
                                <div style="width: 8%;">
                                    <b-form-checkbox @change="selecionarProduto(item)" v-model="item.selecionado"
                                        size="lg" :value="true" :unchecked-value="false" />
                                </div>

                                <div style="width: 50%;">
                                    {{ item.descricaoProduto }}
                                </div>

                                <div style="width: 42%; display: flex; align-items: center; gap: 12px;">
                                    <div style="width: 30%;">{{ item.numeroProduto }}</div>
                                    <div style="width: 20%;">{{ item.tipoMedida }}</div>

                                    <div style="flex: 1;"></div>


                                    <b-button v-if="row.item.status !== statusEmDigitacao"
                                        v-b-tooltip.hover.bottom="'Visualizar'"
                                        @click="abrirConsultaProduto(row.item.id, item)" size="sm" variant="primary"
                                        style="display: flex; align-items: center; justify-content: center;">
                                        <b-icon icon="eye" />
                                    </b-button>
                                </div>
                            </div>

                            <b-table v-if="item.itens && item.itens.length > 0" :items="item.itens"
                                :fields="fieldsItens" :busy="busy" small hover show-empty>
                                <template v-slot:cell(diferenca)="{ item }">
                                    <span :class="classeDiferenca(item.saldoFisico, item.saldoSpalm)"
                                        style="font-weight: 500;">
                                        {{ formatarDiferenca(item.saldoFisico, item.saldoSpalm) }}
                                    </span>
                                </template>

                                <template v-slot:cell(saldoSpalm)="{ item }">
                                    <span style="font-weight: 500;">{{ item.saldoSpalm != null ? item.saldoSpalm : '-'
                                    }}</span>
                                </template>

                                <template v-slot:cell(saldoFisico)="{ item }">
                                    <span style="font-weight: 500;">{{ item.saldoFisico != null ? item.saldoFisico : '-'
                                    }}</span>
                                </template>

                                <template v-slot:cell(lote)="{ item }">
                                    <span class="text-muted">{{ item.lote ? item.lote : "Sem Lote" }}</span>
                                </template>

                                <template v-slot:cell(dataContagem)="{ item }">
                                    {{ formatDate(item.dataContagem) }}
                                </template>

                                <template #empty>
                                    <p class="text-center">Nenhum registro encontrado</p>
                                </template>

                                <template #table-busy>
                                    <div class="text-center text-primary my-2">
                                        <b-spinner class="align-middle" />
                                    </div>
                                </template>
                            </b-table>

                            <b-table v-if="!item.itens || item.itens.length == 0" :items="item.saldos"
                                :fields="fieldsItens" :busy="busy" small hover show-empty>


                                <template v-slot:cell(saldoSpalm)="{ item }">
                                    <span style="font-weight: 500;">{{ item.saldoSpalm
                                    }}</span>
                                </template>

                                <template v-slot:cell(saldoFisico)="{ item }">
                                    <span style="font-weight: 500;">{{ item.saldoFisico }}</span>
                                </template>

                                <template v-slot:cell(lote)="{ item }">
                                    <span class="text-muted">{{ item.lote ? item.lote : "Sem Lote" }}</span>
                                </template>

                                <template #empty>
                                    <p class="text-center">Nenhum registro encontrado</p>
                                </template>

                                <template #table-busy>
                                    <div class="text-center text-primary my-2">
                                        <b-spinner class="align-middle" />
                                    </div>
                                </template>
                            </b-table>
                        </div>
                    </template>


                    <template #cell(expand)="row">
                        <b-button @click="row.toggleDetails" variant="primary" size="sm"
                            class="align-items-center justify-content-center d-flex">{{ row.detailsShowing ? "-"
                                : "+"
                            }}

                        </b-button>
                    </template>


                    <template #cell(dataAbertura)="row">
                        {{ formatDate(row.item.dataAbertura) }}
                    </template>

                    <template #cell(dataFechamento)="row">
                        {{ formatDate(row.item.dataFechamento) }}
                    </template>


                    <template #empty>
                        <p class="text-center">Nenhum registro encontrado</p>
                    </template>

                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle" />
                        </div>
                    </template>

                    <template v-slot:cell(editar)="row">
                        <b-button :disabled="!temPrivilegioEdicao()" v-if="row.item.status === statusEmDigitacao"
                            :id="row.index + 'edit-button'" class="my-2" size="sm" pill variant="primary"
                            @click="editar(row.item)" v-b-tooltip.hover.bottom="'Editar'">
                            <b-icon icon="pencil-square" />
                        </b-button>

                    </template>


                    <template v-slot:cell(inventariar)="row">
                        <b-button :disabled="!temPrivilegioEdicao()" v-if="row.item.status === statusEmDigitacao"
                            :id="row.index + 'inventariar-button'" class="my-2" size="sm" pill variant="primary"
                            @click="inventariar(row.item)" v-b-tooltip.hover.bottom="'Inventariar'">
                            <b-icon icon="list" />
                        </b-button>

                    </template>


                </b-table>

                <b-row style="margin-top: 16px" class="align-items-center">
                    <b-col cols="12" md="6" class="mb-2 mb-md-0">
                        <div class="d-flex align-items-center flex-wrap">
                            <span class="text-muted mr-3" style="font-size: 13px;">
                                Página {{ page }} de {{ totalPage }} - {{ total }} registro(s)
                            </span>
                            <div class="d-flex align-items-center">
                                <span class="text-muted mr-2" style="font-size: 13px;">Mostrar:</span>
                                <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                    :options="perPageOptions" style="width: auto; min-width: 80px;">
                                </b-form-select>
                            </div>
                        </div>
                    </b-col>
                    <b-col cols="12" md="6">
                        <div class="d-flex justify-content-end">
                            <b-pagination v-model="page" :per-page="perPage" :total-rows="total"
                                size="sm"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </b-card>

            <InventarioItemBemConsumoForm :id="id" :inventario="inventario" v-if="showModal"
                :prefix="prefix + title + ' > '" @refreshList="load" @close="fecharModal" />

        </b-card-body>
        <InventarioItemBemConsumoModal :almoxarifado=form.almoxarifado :produto="produto"
            :id="idInventarioItemBemConsumo" v-if="showConsulta" @close="fecharConsulta"
            :prefix="prefix + title + ' > '" />



        <b-modal size="md" button-size="sm" hide-footer v-if="showModalRelatorio" v-model="showModalRelatorio"
            :title="prefix + title + ' > Relatório'" @hidden="fecharModalRelatorio">

            <b-card no-body>
                <b-card-body>
                    <b-card bg-variant="light">

                        <b-spinner v-if="busy" label="Carregando..." class="my-3 d-block mx-auto"></b-spinner>

                        <b-row v-if="!busy">

                            <b-col>
                                <b-form-checkbox v-model="isRelatorioDetalhado" name="detalhado" :value="true"
                                    :unchecked-value="false" class="mr-2">Relatório
                                    detalhado</b-form-checkbox>
                                <b-form-checkbox v-model="mostrarSaldo" name="saldo" :value="true"
                                    :unchecked-value="false" class="mr-2">Mostrar saldo no relatório</b-form-checkbox>

                                <b-form-checkbox v-model="mostrarLocais" name="lotePositivo" :value="true"
                                    :unchecked-value="false" class="mr-2">Mostrar Locais de Armazenamento
                                    no
                                    relatório</b-form-checkbox>

                            </b-col>
                        </b-row>
                        <b-row @submit.prevent="load">
                            <b-col cols="5"></b-col>

                            <b-col cols="2" class="d-flex align-items-center justify-content-center">
                                <div :id="'relatorioXLSX-'">
                                    <img @click="gerarRelatorioGeral('EXCEL')" :src="xlsIcon" class="img img--clickable"
                                        alt="XLSX" />
                                    <b-tooltip :target="'relatorioXLSX-'" title="Relatório em XLS" />
                                </div>

                                <div :id="'relatorioPDF'">
                                    <img @click="gerarRelatorioGeral('PDF')" :src="pdf" class="img img--clickable"
                                        alt="PDF" />
                                    <b-tooltip :target="'relatorioPDF'" title="Relatório em PDF"></b-tooltip>
                                </div>

                            </b-col>

                            <b-col cols="5"></b-col>
                        </b-row>
                    </b-card>
                </b-card-body>
            </b-card>
        </b-modal>

        <b-modal size="xl" button-size="sm" hide-footer v-if="showModalMultiplo" v-model="showModalMultiplo"
            :title="prefix + title + ' > Contagem > Cadastro'" @hidden="fecharModalMultiplo">

            <b-tabs>
                <b-tab v-for="(produto, index) in produtosSelecionados" :title="produto.descricaoProduto"
                    :key="produto.idProduto" v-if="saldos[index] != null && terminouMudarLote">
                    <b-form-group label="Lotes:*">
                        <b-form-select v-model="lote[index]" @change="function (lote) { mudarLote(index, lote) }"
                            :options="saldos[index]" size="sm" />
                    </b-form-group>
                    <lg-form-input invalidFeedback=" " disabled description=""
                        v-model="itemInventarioModelo[index].saldoSpalm" label="Saldo:*" lg="12" sm="12" md="12" />

                    <lg-form-input invalidFeedback=" " description="" v-model="itemInventarioModelo[index].saldoFisico"
                        label="Quant. Inventário:*" lg="12" sm="12" md="12" />

                    <lg-form-input invalidFeedback=" " description=""
                        v-model="itemInventarioModelo[index].justificativa" label="Observação:" lg="12" sm="12"
                        md="12" />

                </b-tab></b-tabs>

            <b-form-row>

                <b-col cols="2"></b-col>
                <b-col cols="8" class="text-center">
                    <b-button id="salvar-item" class=" my-2" size="sm" pill variant="success" @click="salvarItem">
                        <b-icon icon="check-circle" />
                        <b-tooltip target="salvar-item" title="Salvar"></b-tooltip>

                    </b-button>

                    <b-button id="cancelar-item" class=" my-2 ml-2" size="sm" pill variant="danger"
                        @click="fecharModalMultiplo">
                        <b-icon icon="x-circle" />
                        <b-tooltip target="cancelar-item" title="Cancelar"></b-tooltip>

                    </b-button>

                </b-col>
                <b-col cols="2"></b-col>

            </b-form-row>

        </b-modal>


    </b-card>

</template>

<script>
import LgFormInput from "@/core/components/Form/LgFormInput.vue";

import InventarioItemBemConsumoModal from "./InventarioItemBemConsumoModal.vue";
import ResourceService from "@/core/api/ResourceService"
import LgFinderPagePessoa from "@/components/Finders/LgFinderPagePessoa.vue";
import InventarioItemBemConsumoForm from "./InventarioItemBemConsumoForm.vue";
import moment from "moment";
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import LgFinderPageAlmoxarifado from "@/components/Finders/LgFinderPageAlmoxarifado.vue"
import { ListResourceMixin } from "@/core/mixins/resource"
import ConfirmMixin from "@/core/mixins/confirm"
import StatusEnum from "@/core/utils/StatusEnum";
import LgFinderPageSubgrupoProduto from "@/components/Finders/LgFinderPageSubgrupoProduto.vue"
import LgFinderPageProduto from "@/components/Finders/LgFinderPageProduto.vue"
import LgFinderPageClasse from "@/components/Finders/LgFinderPageClasse.vue"
import LgFinderPageLocalArmazenamento from "@/components/Finders/LgFinderPageLocalArmazenamento.vue"
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue"
import PdfIcon from "@/core/assets/icons/pdf.png";
import xlsIcon from "@/core/assets/icons/xls.png";
import DownloadArquivoService from "@/core/utils/DownloadArquivoUtil";
export default {
    components: {
        LgFinderPagePessoa,
        LgFinderPageSubgrupoProduto,
        LgFormConstSelect,
        LgFinderPageProduto,
        LgFinderPageClasse,
        LgFinderPageLocalArmazenamento,
        InventarioItemBemConsumoForm,
        LgFinderPageAlmoxarifado,
        InventarioItemBemConsumoModal,
        LgFormInput
    },
    mixins: [ConfirmMixin, ListResourceMixin],

    props: {
        apenasSaldoPositivo: {
            type: Boolean,
            default: false,
        },

        prefix: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "Inventário Item Bem Consumo"
        }
    },
    data() {

        return {
            inventarioAnual: false,
            isRelatorioDetalhado: false,
            mostrarLocais: false,
            mostrarSaldo: false,
            terminouMudarLote: true,
            produtosSelecionados: [],
            pdf: PdfIcon,
            xlsIcon: xlsIcon,
            produto: null,
            anoAtual: 0,
            editarItem: false,
            idInventarioItemBemConsumo: null,
            showConsulta: false,

            justificativa: "",
            adicionarJustificativa: false,
            adicionarNovoItem: false,
            itemInventario: null,
            item: null,
            statusEmDigitacao: StatusEnum.INVENTARIO_EM_DIGITACAO.value,
            statusEmAndamento: StatusEnum.INVENTARIO_EM_ANDAMENTO.value,

            anos: [],
            ano: null,
            perpage: 10,
            perPageOptions: [10, 25, 50, 100, 1000, 2000],

            showModal: false,
            showModalRelatorio: false,
            showModalMultiplo: false,
            busy: false,
            form: {
                almoxarifado: {},
                produto: {},
                subgrupo: {},
                classe: {},
                localArmazenamento1: {},
                tipoMedida: {},
                localArmazenamento2: {},
                saldoPositivo: this.apenasSaldoPositivo,
                natureza: {},
                itensSemContagem: false,
                disponibilidade: null,
                visibilidade: null,
                departamento: {},
                pessoaComissao: null,
                comissao: null,
                responsavel: null,
            },
            expandSubrow: {},

            tableFields: [

                { key: "expand", label: "", thClass: "w-1", tdClass: "w-1" },
                { key: "almoxarifado", label: "Almoxarifado" },

            ],

            fieldsItens: [

                { key: "lote", label: "Lote" },
                { key: "saldoSpalm", label: "Saldo Spalm" },
                { key: "saldoFisico", label: "Saldo Físico" },
                { key: "diferenca", label: "Diferença", },
                { key: "dataContagem", label: "Data Contagem" },
                { key: "local1", label: "Local Armazenamento 1" },
                { key: "local2", label: "Local Armazenamento 2" },
                { key: "responsavelProduto", label: "Responsável", tdClass: "text-center", thClass: "text-center" },

            ],


        };
    },
    watch: {
        page() {
            this.load();
        },
    },

    methods: {
        selecionarProduto(produto) {
            if (produto.selecionado)
                this.produtosSelecionados.push(produto)
            else {
                const index = this.produtosSelecionados.findIndex(item => item.id === produto.id);
                this.produtosSelecionados.splice(index, 1)[0];

            }
        },
        gerarRelatorioGeral(tipoRelatorio) {

            if (this.isRelatorioDetalhado) {
                this.gerarRelatorioDetalhado(tipoRelatorio);
            }
            else {
                this.gerarRelatorio(tipoRelatorio);
            }
        },
        async gerarRelatorio(tipoRelatorio) {

            this.busy = true;
            const resource = new ResourceService('/api/relatorio/gerar-relatorio-inventario-item-consumo-consolidado');
            const { data } = await resource.getWithParams(`${tipoRelatorio}`, this.montarFiltro());
            DownloadArquivoService(data.arquivoBase64, data.nomeArquivo);
            this.busy = false;

        },

        async gerarRelatorioDetalhado(tipoRelatorio) {

            this.busy = true;
            const resource = new ResourceService('/api/relatorio/gerar-relatorio-inventario-item-consumo-detalhado');
            const { data } = await resource.getWithParams(`${tipoRelatorio}`, this.montarFiltro());
            DownloadArquivoService(data.arquivoBase64, data.nomeArquivo);
            this.busy = false;

        },
        fecharConsulta() {
            this.idInventarioItemBemConsumo = null;
            this.produto = null;
            this.showConsulta = false;
            this.load();
        },
        abrirConsultaProduto(id, produto) {
            this.idInventarioItemBemConsumo = id;
            this.produto = produto;
            this.showConsulta = true;
        },
        async inventariar(inventario) {
            this.busy = true;
            await this.$service.put(`inventariar/${inventario.id}`);
            this.$notify({
                type: "success",
                message: `Inventário iniciado com sucesso!`,
            });

            this.busy = false;
            this.load();

        },
        handleSelectAlmoxarifado(almoxarifado) {
            this.produtosSelecionados = [];
            this.form.almoxarifado = almoxarifado;
            this.load();
        },
        temPrivilegioEdicao() {
            return verificaPrivilegio(PrivilegiosEnum.INVENTARIOS_CONTINUAR);

        },
        temPrivilegioInclusao() {
            return verificaPrivilegio(PrivilegiosEnum.INVENTARIOS_INCLUIR);

        },

        formatDate(date) {

            if (!date || date == "")
                return "";

            return moment(date).format("DD/MM/YYYY");
        },
        formatarDiferenca(saldoFisico, saldoSpalm) {
            if (saldoFisico == null || saldoSpalm == null) return "-";
            const dif = saldoFisico - saldoSpalm;
            if (dif > 0) return `+${dif}`;
            if (dif < 0) return `${dif}`;
            return "0";
        },
        classeDiferenca(saldoFisico, saldoSpalm) {
            if (saldoFisico == null || saldoSpalm == null) return "";
            const dif = saldoFisico - saldoSpalm;
            if (dif > 0) return "text-success";
            if (dif < 0) return "text-danger";
            return "text-muted";
        },

        handleSelectResponsavel(responsavel) {
            this.form.pessoaComissao = responsavel;
            this.form.responsavel = responsavel;
            this.form.comissao = null;
            this.load()
        },
        handleSelectComissao(comissao) {
            this.form.pessoaComissao = comissao;
            this.form.comissao = comissao;
            this.form.responsavel = null;

            this.load()
        },

        handleSelectSubgrupo(subgrupo) {
            this.form.subgrupo = subgrupo
            this.load();
        },

        handleSelectClasse(classe) {
            this.form.classe = classe
            this.load();
        },

        handleSelectLocalArmazenamento1(localArmazenamento1) {
            this.form.localArmazenamento1 = localArmazenamento1
            this.load();
        },
        handleSelectProduto(produto) {
            this.form.produto = produto
            this.load();
        },
        handleSelectLocalArmazenamento2(localArmazenamento2) {
            this.form.localArmazenamento2 = localArmazenamento2
            this.load();
        },

        clearForm() {
            this.produtosSelecionados = [];
            this.form = {
                pessoaComissao: null,
                comissao: null,
                responsavel: null,
                almoxarifado: {},
                produto: {},
                subgrupo: {},
                classe: {},
                localArmazenamento1: {},
                tipoMedida: {},
                localArmazenamento2: {},
                saldoPositivo: this.apenasSaldoPositivo,
                natureza: {},
                itensSemContagem: false,
                disponibilidade: null,
                visibilidade: null,
            };

            const brand = JSON.parse(localStorage.getItem("context"));
            this.form.departamento = brand.departamento;

            this.load();
        },
        montarFiltro() {
            var filtro = {};
            filtro.isRelatorioDetalhado = this.isRelatorioDetalhado;
            filtro.mostrarLocais = this.mostrarLocais;
            filtro.mostrarSaldo = this.mostrarSaldo;
            filtro.carregarSaldos = true;
            if (this.form.almoxarifado.id) {
                filtro.almoxarifado = this.form.almoxarifado.id
            }
            if (this.form.produto.id) {
                filtro.produto = this.form.produto.id
            }
            if (this.form.subgrupo.id) {
                filtro.subgrupo = this.form.subgrupo.id
            }
            if (this.form.classe.id) {
                filtro.classe = this.form.classe.id
            }
            if (this.form.localArmazenamento1.id) {
                filtro.localArmazenamento1 = this.form.localArmazenamento1.id
            }
            if (this.form.localArmazenamento2.id) {
                filtro.localArmazenamento2 = this.form.localArmazenamento2.id
            }
            if (this.form.saldoPositivo) {
                filtro.saldoPositivo = this.form.saldoPositivo
            }
            if (this.form.visibilidade != null) {
                filtro.visibilidade = this.form.visibilidade
            }
            if (this.form.disponibilidade != null) {
                filtro.disponibilidade = this.form.disponibilidade
            }

            filtro.ano = this.ano;
            filtro.pessoa = this.form.responsavel ? this.form.responsavel.id : undefined
            filtro.itensSemContagem = this.form.itensSemContagem;

            return filtro;
        },
        async load() {

            if (!this.ano || !this.form.almoxarifado || !this.form.almoxarifado.id) {
                this.busy = false;
                return;
            }
            

            if (this.ano != this.anoAtual)
                this.produtosSelecionados = [];


            this.busy = true;

            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.montarFiltro(),
            })
                .then(response => {
                    const almoxarifado = !response.content || response.content.length == 0 ? [] : response.content
                        .map(item => ({
                            id: item.id,
                            tipoMedida: item.tipoMedida,
                            estaNoAnoFiscal: item.estaNoAnoFiscal,
                            responsavel: item.responsavel,
                            dataAbertura: item.dataAbertura,
                            dataFechamento: item.dataFechamento,
                            status: item.status,
                            pessoaAssociadaAlmoxarifado: item.pessoaAssociadaAlmoxarifado,
                            idAlmoxarifado: item.idAlmoxarifado,
                            almoxarifado: item.almoxarifado,
                            idProduto: item.idProduto,
                            idItemInventario: item.idItemInventario,
                            numeroProduto: item.numeroProduto,
                            descricaoProduto: item.descricaoProduto,
                            saldoSpalm: item.saldoSpalm,
                            saldoFisico: item.saldoFisico,
                            dataContagem: item.dataContagem,
                            responsavelProduto: item.responsavelProduto,
                            justificativa: item.justificativa,
                            idInventarioItemBemConsumo: item.id,
                            saldoAlmoxarifadoProduto: item.saldoAlmoxarifadoProduto,
                            estaNoMesmoDia: item.estaNoMesmoDia,
                            local1: item.local1,
                            local2: item.local2,
                            saldos: item.saldos,
                        }))
                        .reduce((acc, cur) => {
                            let almox = acc.find(a => a.idAlmoxarifado === cur.idAlmoxarifado)
                            if (!almox) {
                                almox = {
                                    saldos: cur.saldos,
                                    tipoMedida: cur.tipoMedida,
                                    idItemInventario: cur.idItemInventario,
                                    saldoSpalm: cur.saldoSpalm,
                                    estaNoAnoFiscal: cur.estaNoAnoFiscal,
                                    idInventarioItemBemConsumo: cur.idInventarioItemBemConsumo,
                                    saldoAlmoxarifadoProduto: cur.saldoAlmoxarifadoProduto,
                                    idAlmoxarifado: cur.idAlmoxarifado,
                                    almoxarifado: cur.almoxarifado,
                                    responsavel: cur.responsavel,
                                    dataAbertura: cur.dataAbertura,
                                    dataFechamento: cur.dataFechamento,
                                    local1: cur.local1,
                                    local2: cur.local2,

                                    status: cur.status,
                                    pessoaAssociadaAlmoxarifado: cur.pessoaAssociadaAlmoxarifado,
                                    _showDetails: true,
                                    responsavelProduto: cur.responsavelProduto,
                                    estaNoMesmoDia: cur.estaNoMesmoDia,
                                    id: cur.id,
                                    data: []
                                }
                                acc.push(almox)
                            }

                            let produto = almox.data.find(p => p.idProduto === cur.idProduto)

                            if (!produto) {
                                produto = {
                                    selecionado: this.produtosSelecionados.some(
                                        produto => produto.idProduto === cur.idProduto
                                    ),
                                    local1: cur.local1,
                                    local2: cur.local2,

                                    tipoMedida: cur.tipoMedida,
                                    responsavelProduto: cur.responsavelProduto,
                                    estaNoAnoFiscal: cur.estaNoAnoFiscal,
                                    idInventarioItemBemConsumo: cur.idInventarioItemBemConsumo,
                                    id: cur.id,
                                    saldoAlmoxarifadoProduto: cur.saldoAlmoxarifadoProduto,
                                    idProduto: cur.idProduto,
                                    almoxarifado: cur.almoxarifado,
                                    idAlmoxarifado: cur.idAlmoxarifado,
                                    numeroProduto: cur.numeroProduto,
                                    descricaoProduto: cur.descricaoProduto,
                                    saldoSpalm: cur.saldoSpalm,
                                    saldoFisico: cur.saldoFisico,
                                    dataContagem: cur.dataContagem,
                                    estaNoMesmoDia: cur.estaNoMesmoDia,
                                    justificativa: cur.justificativa,
                                    idItemInventario: cur.idItemInventario,
                                    itens: [],
                                    saldos: cur.saldos,
                                }

                                if (produto.idItemInventario) {
                                    produto.itens.push({
                                        local1: produto.local1,
                                        local2: produto.local2, idItemInventario: produto.idItemInventario, lote: produto.lote, responsavelProduto: produto.responsavelProduto, dataContagem: produto.dataContagem, justificativa: produto.justificativa, saldoSpalm: produto.saldoSpalm, saldoFisico: produto.saldoFisico
                                    })
                                }

                                almox.data.push(produto)
                            }


                            return acc
                        }, [])

                    almoxarifado.forEach(alm => {
                        alm.data.forEach(produto => {
                            this.expandSubrow = {
                                ...this.expandSubrow,
                                [produto.idProduto]: true,
                            }
                        })
                    })

                    this.records = almoxarifado
                    this.total = response.totalElements

                })
                .finally(() => {
                    this.busy = false
                })

        },
        fecharModal() {
            this.id = null;
            this.showModal = false;
            this.load();
        },

        abrirModalRelatorio() {
            this.isRelatorioDetalhado = false;
            this.mostrarSaldo = false;
            this.mostrarLocais = false;
            this.showModalRelatorio = true;

        },
        fecharModalRelatorio() {
            this.id = null;
            this.showModalRelatorio = false;
        },
        fecharModalMultiplo() {
            this.showModalMultiplo = false;
            this.produtosSelecionados = [];
            this.load();
        },
        mudarLote(index, lote) {
            this.terminouMudarLote = false;
            this.lote[index] = lote;
            var saldo = this.saldos[index].find(item => item.value == lote);

            this.itemInventarioModelo[index].saldoAlmoxarifadoProduto = saldo.value;
            this.itemInventarioModelo[index].saldoSpalm = saldo.saldoAlmoxarifadoProduto;

            this.terminouMudarLote = true;
        },
        async salvarItem() {

            var itens = [];
            for (var i = 0; i < this.itemInventarioModelo.length; ++i) {
                if (this.lote[i] == 0) {

                    this.$notify({
                        type: "danger",
                        message: `Escolha um Lote para a contagem no produto ` + this.produtosSelecionados[i].descricaoProduto,
                    });
                    return;
                }

                if (!this.itemInventarioModelo[i].saldoFisico || this.itemInventarioModelo[i].saldoFisico <= 0) {
                    this.$notify({
                        type: "danger",
                        message: `Digite a quantidade no inventário no produto ` + this.produtosSelecionados[i].descricaoProduto,
                    });

                    return;

                }

                itens.push({

                    idInventarioItemBemConsumo: this.itemInventarioModelo[i].idInventarioItemBemConsumo,
                    saldoAlmoxarifadoProduto: this.itemInventarioModelo[i].saldoAlmoxarifadoProduto,
                    justificativa: this.itemInventarioModelo[i].justificativa,
                    saldoSpalm: this.itemInventarioModelo[i].saldoSpalm,
                    saldoFisico: this.itemInventarioModelo[i].saldoFisico
                });
            }
            await this.$service.post(`adicionar-item-inventario-item-bem-consumo-multiplo`, itens);
            this.$notify({
                type: "success",
                message: `Contagem adicionada com sucesso!`,
            });
            this.fecharModalMultiplo();
        },
        async openCreateModalMultiplo() {
            this.lote = Array(this.produtosSelecionados.length).fill(0);
            this.itemInventarioModelo = this.produtosSelecionados.map(produto => ({
                idInventarioItemBemConsumo: produto.idInventarioItemBemConsumo,
                justificativa: "",
                saldoSpalm: "",
                saldoFisico: ""
            }));


            this.busy = true;
            this.saldos = [];
            for (var i = 0; i < this.produtosSelecionados.length; ++i) {
                var { data } = await this.$service.getWithParams("item-inventario-saldos",
                    { almoxarifado: this.produtosSelecionados[i].idAlmoxarifado, produto: this.produtosSelecionados[i].idProduto });

                if (data && data.length > 0) {
                    this.saldos.push(data.map(x => ({
                        value: x.saldoAlmoxarifadoProduto,
                        text: x.lote,
                        saldoAlmoxarifadoProduto: x.saldo
                    })));

                }
                else {
                    this.saldos.push(null);
                    this.$notify({
                        type: "danger",
                        message: "Não é possível realizar a contagem do item " + this.produtosSelecionados[i].descricaoProduto + " pois ele não tem saldo no almoxarifado",
                    });
                }
            }
            this.busy = false
            this.showModalMultiplo = true;
        },

        openCreateModal() {
            this.showModal = true;
        },

        editar(item) {
            this.id = item.id;
            this.inventario = {};
            this.showModal = true;
        },

    },
    async beforeMount() {

        this.inventarioAnual = (await new ResourceService("/api/configuracoes-sistema").get('285')).data.valorPropriedade === "1";

        this.$service = new ResourceService("/api/inventario-ibc");
        this.$serviceExercicio = new ResourceService("/api/exercicio-fiscal");

        const brand = JSON.parse(localStorage.getItem("context"))
        this.form.departamento = brand.departamento

        this.busy = true;
        var ano = (await new ResourceService("/api/util").get("buscar-ano-atual")).data;
        this.ano = ano;
        this.anoAtual = ano;
        this.anos = (await this.$serviceExercicio.get("todos-anos")).data;

        this.load();
    },
};
</script>
